const promoConfig = {
  US: {
    dateFormat: "January 13, 2026",
    discount: "15%",
    code: "TOASTNY2026",
  },
  UK: {
    dateFormat: "January 13, 2026",
    discount: "15%",
    code: "TOASTNY2026",
  },
  MIT: {
    dateFormat: "January 13, 2026",
    discount: "15%",
    code: "TOASTNY2026",
  },
  SUCCESS2026: {
    dateFormat: "October 20, 2026",
    discount: "20%",
    code: "SUCCESS2026",
  },
};

const promoTextBody = (format: keyof typeof promoConfig): string => {
  const cfg = promoConfig[format];
  return `<h2 style="text-align: center; margin-bottom: 5px; color: inherit;">Ready for your next move?</h2><h3 style="margin-bottom: 5px; color: inherit;">Save ${cfg.discount} on select Executive Education courses using the code ${cfg.code}</h3><p style="color: inherit;">Build the skills that fuel your growth and position yourself for long-term success. Offer ends ${cfg.dateFormat}. See FAQs below for more details.</p>`;
};

const promoHeaderText = (format: keyof typeof promoConfig): string => {
  const cfg = promoConfig[format];
  return `Your Executive Access is live. Save ${cfg.discount} with code ${cfg.code}. One week only. Ends ${cfg.dateFormat}. `;
};


const promoHeaderTooltipText = (format: keyof typeof promoConfig): string => {
  const cfg = promoConfig[format];
  return `Offer applies to any start date for participating courses where registration is currently open as long as you register and pay by ${cfg.dateFormat} at 11:59 p.m. Eastern Time (U.S.). To redeem the offer for executive education courses, register on getsmarter.com, using code ${cfg.code} at checkout. The discount cannot be combined with any other offers for executive education courses.`;
};

const promoTextDisclaimer = (format: keyof typeof promoConfig): string => {
  const cfg = promoConfig[format];
  return `*Offer applies to any start date for participating courses where registration is currently open as long as you register and pay by ${cfg.dateFormat}, at 11:59 p.m. Eastern Time (U.S.). To redeem the offer for executive education courses, register on getsmarter.com, using code ${cfg.code} at checkout. The discount cannot be combined with any other offers for executive education courses.`;
};

export { promoConfig, promoHeaderText, promoHeaderTooltipText, promoTextBody, promoTextDisclaimer };

